export const paramedicStudents = [
  {
    id: 'pstudent001',
    lastName: 'Carter',
    firstName: 'John',
    email: 'jcarter@example.com'
  },
  {
    id: 'pstudent002',
    lastName: 'Greene',
    firstName: 'Mark',
    email: 'mgreene@example.com'
  },
  {
    id: 'pstudent003',
    lastName: 'Hathaway',
    firstName: 'Carole',
    email: 'chathaway@example.com'
  },
  {
    id: 'pstudent004',
    lastName: 'Benton',
    firstName: 'Peter',
    email: 'pbenton@example.com'
  },
  {
    id: 'pstudent005',
    lastName: 'Ross',
    firstName: 'Doug',
    email: 'dross@example.com'
  },
  {
    id: 'pstudent006',
    lastName: 'Lewis',
    firstName: 'Susan',
    email: 'slewis@example.com'
  },
  {
    id: 'pstudent007',
    lastName: 'Weaver',
    firstName: 'Kerry',
    email: 'kweaver@example.com'
  },
  {
    id: 'pstudent008',
    lastName: 'Romano',
    firstName: 'Robert',
    email: 'rromano@example.com'
  },
];
